import React, {useEffect} from 'react';

import Footer from "../core/layout/footer/footer";

function AMCRegistrationView(props) {
    const {isMobileView, amcRegistrations} = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const renderFooter = () => {
        return (
            <Footer {...props}/>
        );
    };

    return (
        <div>
            <div className="topsection"/>
            <section className="container-x">
                <div className="pt-md-3 pt-0 knowledge-bank-title-pb page-title pb-5">
                    AMC Registrations
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="content pb-4">
                            <strong>Regular Plan and Commission Disclosure:</strong> Simplicity Investing India Pvt Ltd,
                            ARN-87401 is an AMFI-registered Mutual Fund Distributor. All mutual fund schemes offered
                            through our services are Regular Plans, which involve the payment of commission by the Asset
                            Management Companies (AMCs) to us, in the form of trail commission, for the investments we
                            facilitate. We do not deal in Direct Plans or charge customers directly. The commission
                            received or receivable by us for the different competing schemes of various mutual funds is
                            between .50% to 1.60%. We are empaneled with the following mutual funds Companies.
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive mb-5">
                            <table className={isMobileView ? "table table-bordered align-middle" : "table table-bordered align-middle text-start"}>
                                <thead>
                                <tr>
                                    <th scope="col">Sr. No.</th>
                                    <th scope="col">Mutual Fund</th>
                                    <th scope="col">AMC (Fund House)</th>
                                    <th scope="col">SEBI MF Reg. No.</th>
                                    <th scope="col">Registration Date</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    amcRegistrations.map((e, index) =>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{e.mutualFund}</td>
                                            <td>{e.amc}</td>
                                            <td>{e.regNo}</td>
                                            <td>{e.regDate}</td>
                                        </tr>)
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="content pb-5">
                            The information on this website is limited to the mutual fund products we distribute, and you
                            may also consider other alternative products, including Direct Plans available directly from
                            AMCs, before making an investment decision. Please read the Scheme Information Document
                            (SID), Statement of Additional Information (SAI) and Key Information Memorandum (KIM)
                            carefully before investing. Mutual fund investments are subject to market risks, and returns
                            are not guaranteed or assured.
                        </div>
                    </div>
                </div>
            </section>
            {renderFooter()}
        </div>
    );
}

AMCRegistrationView.propTypes = {};

export default AMCRegistrationView;
